import {
  Box,
  Button,
  CardContent,
  Grid,
  Paper,
  Typography,
} from "@mui/material";
import * as React from "react";
import { createTheme } from "@mui/material/styles";
import { green, grey, red } from "@mui/material/colors";
import { useEffect } from "react";
import QuestionDescription from "./QuestionDescription";

const QuestionMultChoiceSolution = ({
  question,
  optionsOrder,
  chosenOptionId,
}) => {
  const correctButtonTheme = createTheme({
    palette: {
      action: {
        disabledBackground: green[500],
        disabled: grey[50],
      },
    },
  });

  const incorrectButtonTheme = createTheme({
    palette: {
      action: {
        disabledBackground: red[500],
        disabled: grey[50],
      },
    },
  });

  const notChosenButtonTheme = createTheme({
    palette: {
      action: {
        disabledBackground: grey[800],
        disabled: grey[50],
      },
    },
  });

  let options = [];
  question["answers"]["incorrect"].forEach((option) =>
    options.push({ ...option, correct: false })
  );
  options.push({ ...question["answers"]["correct"], correct: true });
  options.sort((a, b) => optionsOrder[a.id] - optionsOrder[b.id]);

  const buttons = options.map((option) => (
    <Button
      key={option.id}
      sx={{ mt: 2 }}
      fullWidth={true}
      style={{ textTransform: "none" }}
      variant="contained"
      disabled
      theme={
        option.correct
          ? correctButtonTheme
          : option.id === chosenOptionId
          ? incorrectButtonTheme
          : notChosenButtonTheme
      }
    >
      {option.content}
    </Button>
  ));

  return (
    <Grid container justifyContent="center" alignItems="center" spacing={2}>
      <Grid item>
        <Paper elevation={10} sx={{ m: 1, maxWidth: 1000 }}>
          <CardContent>
            {question["feedback"] && question["feedback"].length ? (
              question["feedback"]
            ) : (
              <QuestionDescription description={question["description"]} />
            )}
            {/*{question["description"]}*/}
            {buttons}
          </CardContent>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default QuestionMultChoiceSolution;
